import { myLabs } from "../../constants/actionTypes";

const INITIAL_STATE = {
  labsListData: "",
  startMyLab: "",
  stopMyLab: "",
  suspendMyLab: "",
  resetMyLab: "",
  shutDownMyLab: "",
  restartDownMyLab: "",
  deletetMyLab: "",
  forceDeletetMyLab: "",
  updateRating: "",
  ratingError: "",
  myLabsLoader: false,
  extensionSuccess: "",
  extensionError: "",
  extsnUpdateSuccess: "",
  extsnUpdateError: "",
  getPackError: "",
  vmDetailsList: "",
  vmDetailsError: "",
  vmAuthConnect: [],
  vmAuthConnectError: "",
  pooledVMDuration: "",
  addDurationResponse: {},
  addDurationLoader: false,
  lab_instructions: [],
  instanceSizeList: [],
  instanceSizeListLoader: false,
  reconfigureVmLoader: false,
  reconfigureVmSuccess: "",
  reconfigureVmError: "",

  reprovision_lab: {
    loading: false,
    data: {}
  },
  vm_state_manage: {
    data: {},
    loading: false,
    success: false,
  },
  manage_vm_export: {
    data: [],
    loading: false,
    success: false,
  },
  restore_vm: {
    loading: false,
    success: true,
    data: {}
  }
};

const myLabsReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case myLabs.MY_LABS_LIST_SUCCESS:
      return {
        ...state,
        labsListData: action.data,
      };
    case myLabs.CLEAR_MY_LABS_LIST:
      return {
        ...state,
        labsListData: "",
      };
    case myLabs.START_MY_LAB_SUCCESS:
      return {
        ...state,
        startMyLab: action.data,
      };
    case myLabs.STOP_MY_LAB_SUCCESS:
      return {
        ...state,
        stopMyLab: action.data,
      };
    case myLabs.SUSPEND_MY_LAB_SUCCESS:
      return {
        ...state,
        suspendMyLab: action.data,
      };
    case myLabs.RESET_MY_LAB_SUCCESS:
      return {
        ...state,
        resetMyLab: action.data,
      };
    case myLabs.SHUTDOWN_MY_LAB_SUCCESS:
      return {
        ...state,
        shutDownMyLab: action.data,
      };
    case myLabs.RESTART_MY_LAB_SUCCESS:
      return {
        ...state,
        restartDownMyLab: action.data,
      };
    case myLabs.DELETE_MY_LAB_SUCCESS:
      return {
        ...state,
        deletetMyLab: action.data,
      };
    case myLabs.FORCE_DELETE_MY_LAB_SUCCESS:
      return {
        ...state,
        forceDeletetMyLab: action.data,
      };
    case myLabs.LOADER_GET_REQUEST:
    case myLabs.LOADER_GET_SUCCESS:
      return {
        ...state,
        myLabsLoader: action.data,
      };
    case myLabs.SUCCESS_UPDATE_RATE:
      return {
        ...state,
        updateRating: action.payload,
      };
    case myLabs.ERROR_UPDATE_RATE:
      return {
        ...state,
        ratingError: action.payload,
      };
    case myLabs.EXTENSION_VALIDITY_GET_SUCCESS:
      return {
        ...state,
        extensionSuccess: action.data,
      };
    case myLabs.EXTENSION_VALIDITY_UPDATE_ERROR:
      return {
        ...state,
        extensionError: action.data,
      };
    case myLabs.EXTENSION_VALIDITY_UPDATE_SUCCESS:
      return {
        ...state,
        extsnUpdateSuccess: action.data,
      };
    case myLabs.EXTENSION_VALIDITY_GET_ERROR:
      return {
        ...state,
        getPackError: action.data,
      };
    case myLabs.SET_WEB_SOCKET_DATA:
      let tempLabList = state.labsListData;
      tempLabList?.data?.results.forEach((element) => {
        if (action?.data?.payload && element?.id === action?.data?.payload?.vm) {
          element.vm_state = action?.data?.payload?.vm_state;
        }
      });
      return {
        ...state,
        labsListData: tempLabList,
      };
    case myLabs.VM_AUTH_CONNECT_SUCCESS:
      let vmAuthConnectData = state.vmAuthConnect;
      const isVmIdPresent = Object.values(vmAuthConnectData).some((key) => {
        return Object.keys(key) === action?.data?.vm_id;
      });
      if (isVmIdPresent) {
        let objIndex = vmAuthConnectData.findIndex((obj) => Object.keys(obj) === action?.data?.vm_id);
        vmAuthConnectData[objIndex] = {
          [action?.data?.vm_id]: action?.data,
        };
      } else {
        vmAuthConnectData.push({
          [action?.data?.vm_id]: action?.data,
        });
      }
      return {
        ...state,
        vmAuthConnect: vmAuthConnectData,
      };
    case myLabs.MY_LABS_LIST_ERROR:
      return {
        ...state,
        labsListError: action.data,
      };
    case myLabs.SUCCESS_VM_DETAILS:
      return {
        ...state,
        vmDetailsList: action.payload[0],
      };
    case myLabs.ERROR_VM_DETAILS:
      return {
        ...state,
        vmDetailsError: action.payload,
      };
    case myLabs.REMOVE_SELECTED_VM_DETAILS:
      return {
        ...state,
        vmDetailsList: "",
      };
    case myLabs.CONNECT_GET_ERROR:
      return {
        ...state,
        vmAuthConnectError: action?.payload,
      };
    case myLabs.POOLED_VM_TIMER_SUCCESS:
      return {
        ...state,
        pooledVMDuration: action?.payload,
      };
    case myLabs.POOLED_VM_TIMER_ERROR:
      return {
        ...state,
        pooledVMDuration: "",
      };
    case myLabs.ADD_VM_DURATION_API_RESPONSE:
      return {
        ...state,
        addDurationResponse: action?.payload,
      };
    case myLabs.ADD_VM_DURATION_LOADER:
      return {
        ...state,
        addDurationLoader: action?.payload,
      };
    case myLabs.SET_LAB_INSTRUCTIONS: {
      return {
        ...state,
        lab_instructions: action?.payload,
      };
    }
    case myLabs.SET_INSTANCE_SIZE_LIST: {
      return {
        ...state,
        instanceSizeList: action?.payload,
      };
    }
    case myLabs.INSTANCE_SIZE_LIST_LOADER: {
      return {
        ...state,
        instanceSizeListLoader: action?.payload,
      };
    }
    case myLabs.RE_CONFIGURE_VM_LOADER: {
      return {
        ...state,
        reconfigureVmLoader: action?.payload,
      };
    }
    case myLabs.RE_CONFIGURE_VM_SUCCESS: {
      return {
        ...state,
        reconfigureVmSuccess: action?.payload,
      };
    }
    case myLabs.RE_CONFIGURE_VM_ERROR: {
      return {
        ...state,
        reconfigureVmError: action?.payload,
      };
    }

    // Reprovison Lab
    case myLabs.RE_PROVISION_LAB_ACTION: {
      return {
        ...state,
        reprovision_lab: {
          ...state?.reprovision_lab,
          loading: true,
        },
      };
    }
    case myLabs.RE_PROVISION_LAB_SUCCESS: {
      return {
        ...state,
        reprovision_lab: {
          ...state?.reprovision_lab,
          data: action?.payload || {},
          loading: false,
        },
      };
    }

    case myLabs.RE_PROVISION_LAB_ERROR: {
      return {
        ...state,
        reprovision_lab: {
          ...state?.reprovision_lab,
          loading: false,
        },
      };
    }
    case myLabs.RE_PROVISION_LAB_RESET: {
      return {
        ...state,
        reprovision_lab: {
          ...state?.reprovision_lab,
          data: {},
        },
      };
    }

    // VM State Management
    case myLabs.VM_STATE_MANAGEMENT_ACTION: {
      return {
        ...state,
        vm_state_manage: {
          ...state?.vm_state_manage,
          data: {},
          loading: true,
          success: false
        },
      };
    }
    case myLabs.VM_STATE_MANAGEMENT_SUCCESS: {
      return {
        ...state,
        vm_state_manage: {
          ...state?.vm_state_manage,
          data: {},
          loading: false,
          success: true,
        },
      };
    }
    case myLabs.VM_STATE_MANAGEMENT_ERROR: {
      return {
        ...state,
        vm_state_manage: {
          ...state?.vm_state_manage,
          data: {},
          loading: false,
          success: false,
        },
      };
    }
    case myLabs.VM_STATE_MANAGEMENT_RESET: {
      return {
        ...state,
        vm_state_manage: {
          ...state?.vm_state_manage,
          data: {},
          loading: false,
          success: false,
        },
      };
    }

    case myLabs.MANAGE_VM_DOWNLOAD_ACTION: {
      return {
        ...state,
        manage_vm_export: {
          ...state?.manage_vm_export,
          loading: true,
        }
      }
    }

    case myLabs.MANAGE_VM_DOWNLOAD_SUCCESS: {
      return {
        ...state,
        manage_vm_export: {
          ...state.manage_vm_export,
          loading: false,
          data: action.payload || [],
          success: true
        }
      }
    }

    case myLabs.MANAGE_VM_DOWNLOAD_ERROR: {
      return {
        ...state,
        manage_vm_export: {
          ...state.manage_vm_export,
          loading: false,
          data: [],
          success: false
        }
      }
    }

    case myLabs.MANAGE_VM_DOWNLOAD_RESET: {
      return {
        ...state,
        manage_vm_export: {
          ...state.manage_vm_export,
          loading: false,
          data: [],
          success: false
        }
      }
    }

    case myLabs.RESTORE_VM_ACTION: {
      return {
        ...state,
        restore_vm: {
          ...state?.restore_vm,
          loading: true,
        }
      }
    }

    case myLabs.RESTORE_VM_SUCCESS: {
      return {
        ...state,
        restore_vm: {
          ...state.restore_vm,
          loading: false,
          data: action.payload || {},
          success: true
        }
      }
    }

    case myLabs.RESTORE_VM_ERROR: {
      return {
        ...state,
        restore_vm: {
          ...state.restore_vm,
          loading: false,
          data: {},
          success: false
        }
      }
    }

    case myLabs.RESTORE_VM_RESET: {
      return {
        ...state,
        restore_vm: {
          ...state.restore_vm,
          loading: false,
          data: {},
          success: false
        }
      }
    }

    default:
      return state;
  }
};

export default myLabsReducer;
